import type { CustomerBundle } from './types';
import { t } from '../lib/i18n';

const DAEMON_TIMEOUT_MS = 30_000;

export class CustomerNotFoundError extends Error {
  constructor() { super('customer not found'); this.name = 'CustomerNotFoundError'; }
}

export async function fetchCustomer(anum: number): Promise<CustomerBundle> {
  const ctl = new AbortController();
  const timer = setTimeout(() => ctl.abort(), DAEMON_TIMEOUT_MS);
  try {
    const res = await fetch(`/api/customer?anum=${anum}`, {
      credentials: 'same-origin',
      signal: ctl.signal,
    });
    if (res.status === 404) throw new CustomerNotFoundError();
    if (res.status === 502 || res.status === 503) {
      throw new Error(t.errors.daemonOffline);
    }
    if (!res.ok) throw new Error(`HTTP ${res.status}`);

    // Daemon wraps as {ok, data, error}. Unwrap.
    const body = await res.json() as { ok: boolean; data?: CustomerBundle; error?: string };
    if (!body.ok) throw new Error(body.error || 'daemon error');
    return body.data!;
  } finally {
    clearTimeout(timer);
  }
}
